export default __webpack_public_path__ + "static/media/incoming-call.0adfd7b1.svg";